"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _utils = require("./utils");

var batteryId = _utils.screeners.ROI_HPQ_4_DAYSLIDE;
var slider = ["0", "1", "2", "3", "4", "5", "6", "7"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  extraText: "",
  type: "dayslider",
  options: slider,
  specific: true
};
var roiQuestions = [// ROI measures (based on HPQ) - 4 questions
{
  prompt: "How many days in the last week did you miss work due to mental or" + " physical health reasons (e.g. stress, fatigue, illness)?"
}, {
  prompt: "On how many days in the last week did you feel so impaired by stress," + " that even though you went to work, your productivity was reduced?"
}, {
  prompt: "On these days when you went to work feeling stressed, what percentage " + "of your time were you as productive as usual?",
  type: "slider",
  options: ["0%", "10%", "20%", "30%", "40%", "50%", "60%", "70%", "80%", "90%", "100%"]
}, {
  prompt: "On how many days in the past week have you felt so stressed or" + " frustrated with work that you considered changing jobs?"
}];
var questions = (0, _utils.wrapBattery)(roiQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var humanReadable = {};
  questions.forEach(function (q, i) {
    humanReadable[q.prompt] = answers[i];
  });
  return {
    roiAbsenteeismDays: answers[0],
    roiPresenteeismDays: answers[1],
    roiPresenteeismPercentProductive: questions[2].options[answers[2]],
    roiTurnoverRiskDays: answers[3],
    humanReadable: humanReadable
  };
}